import React, { useState, useRef } from "react";
import { Button } from "@tvg/design-system";
import LoadingMask from "./LoadingMask";
import { Props } from "./types";
import {
  Wrapper,
  ScrollingMaskWrapper,
  ScrollingMask,
  ButtonsWrapper,
  ButtonWrapper,
  ButtonLabel
} from "./styled-components";

const PillsNav = ({
  pills,
  isLoading,
  hasCrossNavigation,
  hasUserUnverifiedBanner,
  pillsDistanceFromTop
}: Props) => {
  const [hasScrolled, setHasScrolled] = useState(false);
  const buttonsWrapperRef = useRef<HTMLDivElement>(null);

  const handleScroll = () => {
    const { current } = buttonsWrapperRef;
    if (current) {
      // Check if the div has scrolled horizontally
      setHasScrolled(current.scrollLeft > 0);
    }
  };

  if (pills.length === 0 || isLoading) {
    return <LoadingMask qaLabel="pills-loading-mask" />;
  }

  return (
    <Wrapper
      hasCrossNavigation={hasCrossNavigation}
      hasUserUnverifiedBanner={hasUserUnverifiedBanner}
      pillsDistanceFromTop={pillsDistanceFromTop}
    >
      <ScrollingMaskWrapper>
        <ScrollingMask hasScrolled={hasScrolled} />
        <ButtonsWrapper ref={buttonsWrapperRef} onScroll={handleScroll}>
          {pills &&
            pills
              .filter(({ title }) => !!title)
              .map(({ name, title, isActive, onClick }) => (
                <ButtonWrapper isActive={isActive} key={`${name}-${title}`}>
                  <Button
                    qaLabel={`pill-nav-${name.toLocaleLowerCase()}`}
                    variant={isActive ? "primary" : "tertiary"}
                    onPress={onClick}
                  >
                    <ButtonLabel isActive={isActive}>{title}</ButtonLabel>
                  </Button>
                </ButtonWrapper>
              ))}
        </ButtonsWrapper>
      </ScrollingMaskWrapper>
    </Wrapper>
  );
};

export default PillsNav;
